export const ProcessStatusSteppersConstant = [
  'Cadastro',
  'Análise',
  'Financeiro',
  'Aguard. resultado',
  'Em andamento',
  'Encerrado'
];
